import { TRootState } from 'Redux/Reducers';

export const getEventTicketCount = (state: TRootState) => state.eventTicket.maxCount;
